
import Container from "../../common/Container";
import { Row, Col } from "antd";


const Footer = () => {
  return (
    <>
      <div style={{backgroundColor:"#111111",color:"#fff",paddingTop:"24px"}}>
        <Container>
        <Row justify="space-between">
          <Col>
            <Row style={{paddingBottom:"16px"}}>
              <img src="logoalt.png" alt="logoalt.png" style={{display: "block",maxWidth:"171px",maxHeight:"72px",width:"auto",height:"auto"}}/>
            </Row>
            <Row >
            <p>© 2022, Labyrinth</p>
            </Row>
        
          </Col>
          <Col>
              <Row style={{paddingBottom:"8px",justifyContent:"center"}}>
                <p>Join our socials!</p>
              </Row>
              <Row style={{justifyContent:"center"}}>
              <a style={{justifyContent:"center",paddingRight:"12px"}} href="https://medium.com/labyrintherc" target="_blank" rel="noreferrer">
                <Col style={{border:"2px solid white",borderRadius:"50px"}}>
                  
                    <img src="/img/medium.svg" alt="medium.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://t.me/labyrintherc" target="_blank" rel="noreferrer">
                <Col style={{border:"2px solid white",borderRadius:"50px"}}>
                  
                    <img src="/img/tg.svg" alt="tg.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://twitter.com/labyrintherc" target="_blank" rel="noreferrer">
                <Col style={{border:"2px solid white",borderRadius:"50px"}}>
                  
                    <img src="/img/twt.svg" alt="twt.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                <a style={{justifyContent:"center", paddingRight:"12px"}} href="https://github.com/labyrintherc/" target="_blank" rel="noreferrer">
                <Col style={{border:"2px solid white",borderRadius:"50px"}}>
                  
                    <img src="/img/github.svg" alt="git.svg"  style={{width:"48px",height:"48px", padding:"6px"}}/>
                  
                </Col>
                </a>
                
                
              </Row>


              
              
          </Col>
        </Row>
        </Container>
      </div>

    </>
  );
};

export default (Footer);
